/**
 * 获得超前，朝后连续几天的日期
 * @param {number} range
 * @param {string} [type]
 * @memberOf VehicleOverviewComponent
 * @description 获取今天及前后天
 */

export function getRangeDate (range, type) {
  const formatDate = (time) => {
    // 格式化日期，获取今天的日期
    const Dates = new Date(time)
    const year = Dates.getFullYear()
    const month = (Dates.getMonth() + 1) < 10 ? '0' + (Dates.getMonth() + 1) : (Dates.getMonth() + 1)
    const day = Dates.getDate() < 10 ? '0' + Dates.getDate() : Dates.getDate()
    const week = '日一二三四五六'.charAt(Dates.getDay())
    const id = year + '-' + month + '-' + day
    const name = month + '月' + day + '日' + '[周' + week + ']'
    return {
      id: id,
      name: name
    }
  }
  // const now = formatDate(new Date().getTime())
  const resultArr = []
  let changeDate
  if (range) {
    if (type) {
      if (type === 'one') {
        changeDate = formatDate(new Date().getTime() + (1000 * 3600 * 24 * range))
        return changeDate
      }
      if (type === 'more') {
        if (range < 0) {
          for (let i = Math.abs(range); i >= 0; i--) {
            resultArr.push(formatDate(new Date().getTime() + (-1000 * 3600 * 24 * i)))
          }
          return resultArr
        } else {
          for (let i = 1; i <= range; i++) {
            resultArr.push(formatDate(new Date().getTime() + (1000 * 3600 * 24 * i)))
          }
          return resultArr
        }
      }
    } else {
      changeDate = formatDate(new Date().getTime() + (1000 * 3600 * 24 * range))
    }
  }
}

import moment from 'moment'

// 获得当前日期
export function getCurDate() {
  return moment(new Date()).format('YYYY-MM-DD')
}

export function getCurDateTime() {
  return moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
}

// 获得当前日期增加年、月、日后的最终日期
export function getEndData(year, month, day) {
  const _n = moment(new Date()).add(year, 'year').add(month, 'month').add(day, 'day')
  const _y = _n.format('YYYY')
  const _m = _n.format('MM')
  const _d = _n.format('DD')
  return _y + '-' + _m + '-' + _d
}

// 获得下个月的固定日期
export function getNextMonthFixDay(day) {
  const _n = moment(new Date()).add(1, 'month')
  const _y = _n.format('YYYY')
  const _m = _n.format('MM')
  if (day >= 10) {
    return _y + '-' + _m + '-' + day
  } else {
    return _y + '-' + _m + '-0' + day
  }
}

// 格式化日期
export function formatDate(datetime) {
  const tmp = new Date(datetime)
  if (tmp.toString() === 'Invalid Date') {
    return ''
  } else {
    return moment(tmp).format('YYYY-MM-DD')
  }
}

// 动态排序函数
export function compareValues(key, order = 'asc') {
  return function(a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // 属性在这两个对象上都不存在
      return 0
    }
    const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key]
    const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key]
    let comparison = 0
    if (varA > varB) {
      comparison = 1
    } else if (varA < varB) {
      comparison = -1
    }
    return (
      (order === 'desc') ? (comparison * -1) : comparison
    )
  }
}

